import React, { useState, useContext, useRef, useEffect,
                useCallback, } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShopperContext } from '../context/shopper'

import SkuFoundRow from '../components/SkuFoundRow'
import Checkbox from '../components/Checkbox'

import { useUtils } from "../hooks/useUtils";
import { FoodDetails } from './FoodDetails';
//import CategoryHeader from '../components/CategoryHeader'

import { usePhrasing } from "../hooks/useSkuUtils";
import { useStyles } from "../hooks/useStyles";
import * as Constants from '../constants';
import { doesArrayExist } from '../utils';
import { HeadingBuilder } from './HeadingBuilder';

import Table from 'react-bootstrap/Table';
import { useTranslation } from "react-i18next";

// Show skus that match search criteria for Shopper to clone for their own Circle.
// Shopper can check a box to open a SkuForm prepopulated with values from the picked Sku.
export const SkusFound = ({otherSkus, circle_id, currency_symbol, cstu,
                            wants12digitEAN,
                            identifier,  // the search form's Lookup ID
                            showSearchResults}) => {
  console.log("skfd A", circle_id, otherSkus)
  const {
    foodFactLookupIsActive,  // a feature flag: are we using the FoodFacts API?
    stageOffSku,
    foodFactInfo, setFoodFactInfo,
    signedIn
        } = useContext(ShopperContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getOColTippyContent, getIdColTippyText } = usePhrasing();

  const { textAlignLeft } = useStyles();

  const shoppingListTableId = 'ShoppingListMainTable';

  const [showIdentifier, setShowIdentifier]             = useState(false);
  const [showPostalCode, setShowPostalCode]             = useState(false);
  const [showUnitCost, setShowUnitCost]                 = useState(true);
  const toggleShowUnitCostColumn = () => {
    setShowUnitCost(prev => !prev);
  };

  const [showSkuDetailsColumn, setShowSkuDetailsColumn] = useState(false);
  const toggleShowSkuDetailsColumn = () => {
    setShowSkuDetailsColumn(prev => !prev);
    console.log("srsc", showSkuDetailsColumn);
  };

  const [ foodFactsLoading, setFoodFactsLoading ] = useState(false);
  const resetFoodFactInfo = useCallback(() => {
    setFoodFactInfo(null);
  }, [setFoodFactInfo]);

  // Flush the OFF panel whenever a NEW search response arrives.
  // 'otherSkus' (the real search result) gets a fresh array identity
  // on every Submit, so this fires per search. Staging a pseudo-sku
  // no longer touches foundSkus, so it can't trip this.
  // Skip the mount run: foodFactInfo lives in context so the panel
  // survives Back navigation from the Add Sku page, and clearing on
  // mount would defeat that.
  const skipMountFlush = useRef(true);
  useEffect(() => {
    if (skipMountFlush.current) {
      skipMountFlush.current = false;
      return;
    }
    resetFoodFactInfo();
  }, [otherSkus, resetFoodFactInfo]);

  const {
    identifierFitsUpcRegex,
    fetchFoodFactInfo,
    convertTo12DigitIfEAN13code,
        } = useUtils();

  // Stage the OFF product info as a typeless pseudo-sku and go to the
  // Add Sku page. The shopper picks the sku type there as usual (with
  // all the explanatory copy), and SkuForm prefills these fields for
  // whichever type they pick. Omitting 'type' is what keeps the
  // chooser showing instead of jumping straight to one form.
  const addOffInfoToMaybeList = () => {
    const code =
      convertTo12DigitIfEAN13code(foodFactInfo.code, wants12digitEAN);
    stageOffSku({
      uuuid:      `off-${code}`,
      identifier: code,
      label:      foodFactInfo.product_name         || '',
      brand:      foodFactInfo.brands               || '',
      quantity:   foodFactInfo.product_quantity     || '',
      units:      foodFactInfo.product_quantity_unit || '',
    });
    navigate(`/circles/${circle_id}/skus/off-${code}`);
  };

  const identifierMatchesUpc = identifierFitsUpcRegex.test(identifier);

  const upcCode =
    identifierMatchesUpc
      ? identifier
      : null;

  // Show a row of Sku attributes for each Sku

  function s_by_sku_cat_brand_label_identifier( a, b )
  {
    //console.log("sbsli", a)
    if ( a.category && b.category){
    if ( a.category < b.category){
      return -1;
    }
    if ( a.category > b.category){
      return 1;
    }
    }

    if ( a.brand && b.brand ){
    if ( a.brand.toLowerCase() < b.brand.toLowerCase() ){
      return -1;
    }
    if ( a.brand.toLowerCase() > b.brand.toLowerCase() ){
      return 1;
    }
    }

    if ( a.label && b.label ){
    if ( a.label.toLowerCase() < b.label.toLowerCase() ){
      return -1;
    }
    if ( a.label.toLowerCase() > b.label.toLowerCase() ){
      return 1;
    }
    }

    if ( a.identifier && b.identifier){
    if ( a.identifier < b.identifier){
      return -1;
    }
    if ( a.identifier > b.identifier){
      return 1;
    }
    }

    return 0;
  }

  // After a search, scroll its outcome into view (matters on a phone,
  // where the outcome can land below the fold): the results heading
  // when there are matches, or — when a UPC search finds nothing — the
  // 'Search for product info' invite.
  const searchSubmitRef = useRef(null);
  const offInviteRef = useRef(null);
  useEffect(() => {
    if (!signedIn  ||  !showSearchResults) { return; }
    if (otherSkus.length > 0) {
      searchSubmitRef.current?.scrollIntoView();
    } else if (foodFactLookupIsActive  &&  identifierMatchesUpc) {
      offInviteRef.current?.scrollIntoView();
    }
  }, [signedIn, showSearchResults, otherSkus,
      foodFactLookupIsActive, identifierMatchesUpc]);

  // When an OFF lookup returns a hit, scroll the product panel into
  // view by anchoring the subheadline at the top. Skip the mount run
  // so returning via Back (foodFactInfo already set) doesn't scroll
  // the search form off-screen.
  const subheadRef = useRef(null);
  const skipMountPanelScroll = useRef(true);
  useEffect(() => {
    if (skipMountPanelScroll.current) {
      skipMountPanelScroll.current = false;
      return;
    }
    if (signedIn  &&  foodFactInfo) {
      subheadRef.current?.scrollIntoView();
    }
  }, [signedIn, foodFactInfo]);

  if (signedIn) {
    const skusFoundRows =
      doesArrayExist(otherSkus) && otherSkus.length > 0
        ?
          otherSkus.sort( s_by_sku_cat_brand_label_identifier )
            .map(os => {
              console.log('sfr os', os);

              const oi = <SkuFoundRow
                        showSkuDetailsColumn={showSkuDetailsColumn}
                        circle_id={circle_id}
                        currency_symbol={currency_symbol}
                        cstu={cstu}
                        otherSku={os}
                        showIdentifier={showIdentifier}
                        showPostalCode={showPostalCode}
                        showUnitCost={showUnitCost}
                        key={os.uuuid}
                    />

              return [oi];
          })
        : null;
    console.log('SkusFound.js skusFoundRows: ', skusFoundRows);

    const o_colTippyText =
      getOColTippyContent ({ isForTextNotAudio: true, isForSkusFound: true });

    const o_colAudioTippyText =
      getOColTippyContent ({ isForTextNotAudio: false, isForSkusFound: true });

    const copySkuHeadline =
        t('sku.formPart.skusFoundHeadlineLabel010')
      + Constants.O_COL_SYM
      + t('sku.formPart.skusFoundHeadlineLabel020')

    const zip_colTippyText =
        t('global.label.click')
      + " '"
      + t('global.label.xip')
      + "' "
      + t('sku.searchOtherCirclesForSku.tippyContentZipColHead')

    const handleIdClick = event => {
      setShowIdentifier(current => !current);
    };

    const handlePostalCodeClick = event => {
      setShowPostalCode(current => !current);
    };

    // not returning <article> since caller is applying that tag,
    // i.e. this stuff will slide into caller's <article>
    return (
      <>
        <hr/>
        { skusFoundRows
          ? <h3 id="YourSkuSearchResults" ref={searchSubmitRef} tabIndex="-1">
              {copySkuHeadline}
              {/* Search Results: Click '〇' to copy a Sku */}
            </h3>
          : null
        }
        <h5 ref={subheadRef} tabIndex="-1">
          {t('sku.formPart.skusFoundSubheadLabel')}
          {/* (Use the filters above to search for Skus to add to the Circle's Maybe-List) */}
        </h5>
        { skusFoundRows
          ? <Checkbox
              isChecked={showUnitCost}
              setIsChecked={toggleShowUnitCostColumn}
              label={ t('sku.toggleButtonToShowUnitCost.labelToShowUnitCost') }
              // Show 'Unit Cost' column?
              tippyAlert={t('sku.toggleButtonToShowUnitCost.tippyContent')}
            />
          : null
        }

        { skusFoundRows
          ? <Checkbox
              isChecked={showSkuDetailsColumn}
              setIsChecked={toggleShowSkuDetailsColumn}
              label={ t('sku.toggleButtonToShowDetails.labelToShowSkuDetails') }
              // Show 'Sku Details' column?
              tippyAlert={ t('sku.toggleButtonToShowDetails.tippyContent') }
            />
          : null
        }

        { skusFoundRows
          ? <>
              <br/>
              <Table id={shoppingListTableId}
                     style={textAlignLeft}
                     striped bordered hover
                     size="sm" >
              <thead>
                <tr>
                  <th>
                    <HeadingBuilder
                      containerType  = "container-hug-bottom-left"
                      headingText    = {Constants.O_COL_SYM}
                      //  O
                      tippyAlertText = {o_colTippyText}
                      tippyAlertAudio= {o_colAudioTippyText}
                      tippyText      = {o_colTippyText}
                      // Click a circle under the 'O' sign to choose that row's search results as the starting material for adding a new Sku to your Circle.
                    />
                  </th>
                  <th>
                    <HeadingBuilder
                      containerType  = "container-hug-bottom"
                      headingText    = {t('ordersList.id_col.label')}
                      // ID
                      buttonAction   = {handleIdClick}
                      tippyAlertText = {getIdColTippyText()}
                      tippyText      = {Constants.DOT}
                  // Click 'ID' button to toggle showing identifier values below.
                    />
                  </th>
                  <th>
                    <HeadingBuilder
                      containerType  = "container-hug-bottom-left"
                      headingText    = {t('global.label.xip')}
                      // Xip
                      buttonAction   = {handlePostalCodeClick}
                      tippyAlertText = {zip_colTippyText}
                      tippyText      = {zip_colTippyText}
                      // Click 'Xip' to toggle showing the Xip Codes of where...
                    />
                  </th>
                  <th>
                    <HeadingBuilder
                      containerType  = "container-hug-bottom-left"
                      headingText    = {t('sku.brand.label')}
                      // Brand
                      tippyAlertText = {t('sku.brand.tippyContent')}
                      tippyText      = {t('sku.brand.tippyContent')}
                    />
                  </th>
                  <th>
                    <HeadingBuilder
                      containerType  = "container-hug-bottom-left"
                      headingText    = {t('sku.label.label')}
                      // Name/Label
                      tippyAlertText = {t('sku.label.tippyContentSearch')}
                      tippyText      = {t('sku.label.tippyContentSearch')}
                    />
                  </th>
                  <th>
                    <HeadingBuilder
                      containerType  = "container-hug-bottom-left"
                      headingText    = {t('ordersList.store_col.label')}
                      // Store
                    />
                  </th>
                  <th>
                    <HeadingBuilder
                      containerType  = "container-hug-bottom-left"
                      headingText    = {t('sku.qty_units.label')}
                      // Qty
                      tippyAlertText = {t('sku.qty_units.tippyContent')}
                      tippyText      = {t('sku.qty_units.tippyContent')}
                    />
                  </th>
                  <th>
                    <HeadingBuilder
                      containerType  = "container-hug-bottom"
                      headingText    = {t('ordersList.price_col.label')}
                      // Price
                      tippyAlertText = {t('ordersList.price_col.tippyContentSearch')}
                      tippyText      = {t('ordersList.price_col.tippyContentSearch')}
                    />
                  </th>
                  { showUnitCost
                    ? <th>
                        <HeadingBuilder
                          containerType  = "container-hug-bottom-left"
                          headingText    = {t('ordersList.unit_cost_col.label')}
                          // Unit Count
                          tippyAlertText = {t('ordersList.unit_cost_col.tippyContentSearch')}
                          tippyText      = {t('ordersList.unit_cost_col.tippyContentSearch')}
                        />
                      </th>
                    : null
                  }
                  <th>
                    { showSkuDetailsColumn
                      ? <HeadingBuilder
                          containerType  = "container-hug-bottom-left"
                          headingText    = {t('sku.detail.label')}
                          // Details
                          tippyAlertText = {t('sku.detail.tippyContentSearch')}
                          tippyText      = {t('sku.detail.tippyContentSearch')}
                        />
                      : null
                    }
                  </th>
                </tr>
              </thead>
              <tbody>
                {skusFoundRows.flat(1)}
              </tbody>
              </Table>
            </>
          : showSearchResults
            // A <p> can't contain the block elements below (the
            // browser would auto-close it), so wrap in a <div>.
            ? <div ref={offInviteRef} tabIndex="-1">
                <p>
                  {t('sku.formPart.noSkusFound')}
                  {/* No Skus found for this Search */}
                </p>

        {/* Only invite an OFF lookup when the feature is on and the
            Lookup ID is UPC-shaped — otherwise the heading renders
            uselessly (upcCode 'null', no button). */}
        {(foodFactLookupIsActive && identifierMatchesUpc) && (
        <HeadingBuilder
          headingText   =
            {t('sku.formPart.offSearchLabel', { upcCode: upcCode, })}
          // Search for product info for {{upcCode}}

          buttonAction  = {
            () => {fetchFoodFactInfo({
                    barcode:                identifier,
                    fnSetFoodFactsLoading:  setFoodFactsLoading,
                    fnSetFoodFactInfo:      setFoodFactInfo,
                  })}
          }
          goButtonText  = {
            foodFactsLoading
              ? '...'
              : Constants.GET_ICON_RT_ARROW
          }
          tippyText      = {Constants.DOT}
          tippyAlertText = {t('barcode.lookup.tippyContent')}
        />
        )}
              </div>
            : null
        }
        {/* The OFF panel renders outside the search-results branch:
            foodFactInfo lives in context, so Back navigation from the
            Add Sku page can land here (showSearchResults false) and
            still show the panel with its Add-to-Maybe-List button. */}
        {foodFactInfo && (
          /* Tailwind card so the OFF info doesn't splash across the
             whole page width */
          <div className="mt-5 max-w-sm rounded-lg border p-4 shadow-sm">
            <h5>{foodFactInfo.product_name ||
                  t('barcode.lookup.noProductName')}</h5>
                  {/*  || No Name Found */}
            <h6>{foodFactInfo.product_name_en_imported}</h6>
            <div className="flex gap-3 mt-2">
              <img
                /* image_front_url is the contributor-selected front
                   photo — less mismatch-prone than image_url */
                src={foodFactInfo.image_front_url ||
                      foodFactInfo.image_url}
                alt="Product"
                className="w-[100px] shrink-0 self-start object-contain"
              />
              {/* min-w-0 lets long text (e.g. ingredients) wrap
                  instead of widening the card */}
              <div className="min-w-0 flex-1">
                <FoodDetails
                  foodFactInfo    = {foodFactInfo}
                  wants12digitEAN = {wants12digitEAN}
                />
              </div>
            </div>
            <HeadingBuilder
              containerType  = 'container-left'
              Size           = 'h5'
              headingText    = {t('barcode.lookup.addToMaybeListLabel')}
              // Add Item to Maybe-List
              buttonAction   = {addOffInfoToMaybeList}
              goButtonText   = {Constants.GET_ICON_RT_ARROW}
              tippyText      = {Constants.DOT}
              tippyAlertText = {t('barcode.lookup.addToMaybeListTippy')}
            />
            <HeadingBuilder
              containerType  = 'container-left'
              Size           = 'h5'
              headingText    = {t('barcode.lookup.closeLabel')}
              // Clear Product Info
              buttonAction   = {resetFoodFactInfo}
              goButtonText   = {Constants.GET_ICON_RT_ARROW}
              tippyText      = {Constants.DOT}
            />
            {/* Attribution required by OFF's licenses: ODbL (data) and
                CC-BY-SA (image). Sits next to both so the credit is
                "reasonably calculated to make users aware". */}
            <small className="block mt-3 text-xs">
              {t('barcode.attribution.prefix')}{' '}
              <a href="https://world.openfoodfacts.org"
                 target="_blank" rel="noopener noreferrer">
                Open Food Facts
              </a>
              {t('barcode.attribution.suffix')}
            </small>
          </div>
        )}
      </>
    )
  } else {
    return (
      <HeadingBuilder
        Size = 'h3'
        headingText = {t('global.notSignedInMessage')}
        // Not Authorized - Please Sign in or Sign up
      />
    )
  }
}

export default SkusFound;
